import TemplateEditTableComponent from "~/components/pages/supervisor/templates/edit/table";
import { TemplateStateProvider } from "~/hooks/use-template";

export default function TemplateEditTablePage() {
  return (
    <TemplateStateProvider>
      <TemplateEditTableComponent />
    </TemplateStateProvider>
  );
}
